export default __webpack_public_path__ + "static/media/PendingPickupIcon.64f761c7.svg";